import { create } from 'zustand';

export interface ViewportState {
  // Camera
  panX: number;
  panY: number;
  zoom: number;
  viewportWidth: number;
  viewportHeight: number;

  // Flags
  shouldFitToView: boolean;
  isAutoOrganizing: boolean;
  isBoardTransitioning: boolean;
  lastBoardNavAt: number;

  // Tools
  activeTool: 'select' | 'pan' | 'board' | 'sticky' | 'text_card' | 'document' | 'image' | 'file' | 'link' | 'arrow';
  hoverPreviewEnabled: boolean;

  // Actions
  setPan: (x: number, y: number) => void;
  setZoom: (zoom: number) => void;
  setViewportSize: (width: number, height: number) => void;
  setActiveTool: (tool: ViewportState['activeTool']) => void;
  toggleHoverPreview: () => void;
  clearShouldFitToView: () => void;
  setAutoOrganizing: (value: boolean) => void;
  setBoardTransitioning: (value: boolean) => void;
  setLastBoardNavAt: (value: number) => void;
  setShouldFitToView: (value: boolean) => void;
}

export const useViewportStore = create<ViewportState>((set) => ({
  panX: 0,
  panY: 0,
  zoom: 1,
  viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
  viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 800,
  shouldFitToView: false,
  isAutoOrganizing: false,
  isBoardTransitioning: false,
  lastBoardNavAt: 0,
  activeTool: 'select',
  hoverPreviewEnabled: false,

  setPan: (x, y) => set({ panX: x, panY: y }),
  setZoom: (zoom) => set({ zoom: Math.max(0.08, Math.min(4.1, zoom)) }),
  setViewportSize: (width, height) => set({ viewportWidth: width, viewportHeight: height }),
  setActiveTool: (tool) => set({ activeTool: tool }),
  toggleHoverPreview: () => set((state) => ({ hoverPreviewEnabled: !state.hoverPreviewEnabled })),
  clearShouldFitToView: () => set({ shouldFitToView: false }),
  setAutoOrganizing: (value) => set({ isAutoOrganizing: value }),
  setBoardTransitioning: (value) => set({ isBoardTransitioning: value }),
  setLastBoardNavAt: (value) => set({ lastBoardNavAt: value }),
  setShouldFitToView: (value) => set({ shouldFitToView: value }),
}));
